import logo from './logo.svg';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <div className="image-container">
          <img src="https://i.imgflip.com/9c7vuc.jpg" title="made at imgflip.com"/>
        </div>
        <p>
          Take a chance!
        </p>
        {/* <a
          className="App-link"
          href="https://reactjs.org"
          target="_blank"
          rel="noopener noreferrer"
        >
          Learn React
        </a> */}
        <img src="/favorite-transparent.png" alt="logo" className="logo-image"/>
      </header>
    </div>
  );
}

export default App;
